module.exports = __webpack_public_path__ + "media/bootstrap-icons/award-d49bf9f5.svg";